<template>
  <div class="size-7">
        <!-- List name -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control"><a class="button is-static">gameslist.</a></p>
                    <p class="control">
                        <input class="input oc-input" type="text" v-model="listName" />
                    </p>
                </div>
            </div>
        </div>

        <!-- games -->
        <table class="table">
            <tr>
                <th></th>
                <th>DB Id</th>
                <th>Prov.</th>
                <th>GameId</th>
                <th>Name</th>
                <th></th>
                <th></th>
            </tr>
            <tr v-for="(game, index) in listGames" :key="game.gameId">
                <td>{{index + 1}}</td>
                <td>{{game.id}}</td>
                <td>{{game.provider}}</td>
                <td>{{game.gameId}}</td>
                <td>{{game.name}}</td>
                <td><img :src="game.thumbnailUrl" class="thumbnail" /></td>
                <td><a class="button is-small is-danger" @click="removeGameFromList(game.id)">remove</a></td>
            </tr>
        </table>

        <!-- save button -->
        <div class="field is-horizontal">
            <div class="field-label">
                <!-- Left empty for spacing -->
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <button class="button is-primary" @click="saveList()">Save</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- search field -->
        <div class="field is-horizontal" style="margin-top: 3rem;">
            <div class="field-label is-normal">
                <label class="label">Search games</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control">
                        <input class="input oc-input" type="text" v-model="searchStr" />
                    </p>
                    <div class="control">
                        <button class="button" @click="searchGames()">Search</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- games to add -->
        <table class="table">
            <tr>
                <th></th>
                <th>DB Id</th>
                <th>Prov.</th>
                <th>GameId</th>
                <th>Name</th>
                <th></th>
                <th></th>
            </tr>
            <tr v-for="(game, index) in gamesToAdd" :key="game.gameId">
                <td>{{index + 1}}</td>
                <td>{{game.id}}</td>
                <td>{{game.provider}}</td>
                <td>{{game.gameId}}</td>
                <td>{{game.name}}</td>
                <td><img :src="game.thumbnailUrl" class="thumbnail" /></td>
                <td><a class="button is-small is-success" @click="addGameToList(game.id)">add</a></td>
            </tr>
        </table>
  </div>
</template>
<script>
import gamesListService from '../../../../services/gamesList.service';
import gamesService from '../../../../services/game.service';
import breadcrumbsService from '../../../../services/breadcrumbs.service'

export default {
    name: 'client-games-lists-list',
    data() {
        return {
            list: {
                name: '',
                gameIds: []
            },
            listName: '',
            listGames: [],
            searchStr: '',
            gamesToAdd: []
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        listId() {
            return this.$route.params.listId;
        }
    },
    watch: {
        async clientId() {
            await this.resetList();
        },
        async listId() {
            await this.resetList();
        }
    },
    async mounted() {
        await this.loadList();
    },
    methods: {
        async loadList() {
            if (this.listId !== 'new') {
                const lists = await gamesListService.getClientGamesLists(this.clientId);
                this.list = lists.find(l => l.id === this.listId);
                this.listName = this.list.name.substring(10);
                await this.loadListGames();
            }

            breadcrumbsService.dynamic.set({ key: "list", func: () => this.list.name || 'new' });
        },
        async loadListGames() {
            this.listGames = await gamesService.byIds(this.list.gameIds);
        },
        async resetList() {
            this.list = {
                name: '',
                gameIds: []
            };
            this.listName = '';
            this.listGames = [];
            this.searchStr = '';
            this.gamesToAdd = [];
            
            await this.loadList();
        },
        async removeGameFromList(gameId) {
            if (this.list.gameIds.includes(gameId)) {
                this.list.gameIds = this.list.gameIds.filter(gId => gId !== gameId);
                await this.loadListGames();
            }
        },
        async addGameToList(gameId) {
            if (!this.list.gameIds.includes(gameId)) {
                this.list.gameIds.push(gameId);
                await this.loadListGames();
            }
        },
        async saveList() {
            if (!this.listName) return;

            this.list.name = `gameslist.${this.listName}`;
            if (this.list.id) {
                await gamesListService.updateGamesList(this.list);
            } else {
                this.list.clientId = this.clientId;
                await gamesListService.createGamesList(this.list);
                this.$router.push({ name: 'client-games-lists', params: { clientId: this.clientId } });
            }
        },
        async searchGames() {
            this.gamesToAdd = await gamesService.searchClientGames(this.clientId, this.searchStr);
        }
    }
};
</script>
<style scoped>
.thumbnail {
    max-width: 50px;
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/games/lists-list.vue